import { UserDashboardConfig, WorkspaceWithProjects } from '../types';

export function getUserDashboardConfigWithUpdateWorkspace(
  currentUserDashboardConfig: UserDashboardConfig,
  newWorkspaceConfig: WorkspaceWithProjects
) {
  const existingWorkspaceIndex =
    currentUserDashboardConfig.workspaces.findIndex(
      (w) => w.id == newWorkspaceConfig.id
    );
  const shouldUpdateExisiting = existingWorkspaceIndex > -1;

  if (shouldUpdateExisiting) {
    currentUserDashboardConfig.workspaces[existingWorkspaceIndex] =
      newWorkspaceConfig;
  }

  const newWorkspaces = shouldUpdateExisiting
    ? currentUserDashboardConfig.workspaces
    : [...currentUserDashboardConfig.workspaces, newWorkspaceConfig];
  return {
    userDashboard: {
      ...currentUserDashboardConfig,
      workspaces: newWorkspaces,
    },
  };
}

export function getUserDashboardConfigWithUpdatedWorkspaceProjectsList(
  currentUserDashboardConfig: UserDashboardConfig,
  workspaceId: number,
  projectsIds: number[]
) {
  return {
    userDashboard: {
      ...currentUserDashboardConfig,
      workspaces: currentUserDashboardConfig.workspaces.map((w) =>
        w.id === workspaceId
          ? {
              ...w,
              allowedProjectIds: projectsIds,
            }
          : w
      ),
    },
  };
}
